/* eslint-disable */
export enum RequestStatusEnum {
  DRAFT = "DRAFT",
  DRAFT_ASSIGNED = "DRAFT_ASSIGNED",
  SUBMITTED = "SUBMITTED",
  CLOSED = "CLOSED",
  STALLED = "STALLED",
  IN_PROGRESS = "IN_PROGRESS",
  LODGED = "LODGED",
  FINISHED = "FINISHED",
  CANCELLED = "CANCELLED",
  CONNECTED = "CONNECTED",
  NONE = "NONE",
  DISCARDED = "DISCARDED",
  FAILED = "FAILED",
  COMPLETED = "COMPLETED",
  CT_SUBMITTED = "CT_SUBMITTED",
  CT_NOT_REQUIRED = "CT_NOT_REQUIRED",
  PROCESSED = "PROCESSED",
}

export enum ChangeRequestComputedStatusEnum {
  DRAFT = "DRAFT",
  RECEIVED = "RECEIVED",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
  SCHEDULED = "SCHEDULED",
}

export enum RemoveSupplyComputedStatusEnum {
  DRAFT = "DRAFT",
  RECEIVED = "RECEIVED",
  VERIFICATION_SENT = "VERIFICATION_SENT",
  VERIFICATION_COMPLETED = "VERIFICATION_COMPLETED",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}

export enum RequestChannelEnum {
  ORIGIN_CONNECT = "ORIGIN_CONNECT",
  CONNECT_ASSIST = "CONNECT_ASSIST",
  NETWORK = "NETWORK",
  MANUAL = "MANUAL",
  UNKNOWN = "UNKNOWN",
  CLAIM = "CLAIM",
}

export enum State {
  ACT = "ACT",
  NSW = "NSW",
  NT = "NT",
  QLD = "QLD",
  SA = "SA",
  TAS = "TAS",
  VIC = "VIC",
  WA = "WA",
}

export enum ServiceTypeEnum {
  ELECTRICITY = "ELECTRICITY",
  GAS = "GAS",
  INTERNET = "INTERNET",
}

export enum AccountPayerEnum {
  COMPANY = "COMPANY",
  SOMEONE_ELSE = "SOMEONE_ELSE",
  ME_MY_COMPANY = "ME_MY_COMPANY",
}

export enum ConnectionTypeEnum {
  PERMANENT = "PERMANENT",
  TEMPORARY = "TEMPORARY",
  TEMPPERM = "TEMPPERM",
  SERVICE_CONNECTION_AND_METER_FIX = "SERVICE_CONNECTION_AND_METER_FIX",
  METER_FIX = "METER_FIX",
  SERVICE_CONNECTION = "SERVICE_CONNECTION",
  CAN_RETAIL = "CAN_RETAIL",
  PRE_INSTALL_NBN = "PRE_INSTALL_NBN",
  ADDRESS_NOT_FOUND = "ADDRESS_NOT_FOUND",
}

export enum MessageDirectionEnum {
  INBOUND = "INBOUND",
  OUTBOUND = "OUTBOUND",
}

export enum RequestLifecycle {
  IN_PROGRESS = "IN_PROGRESS",
  BOOKED = "BOOKED",
  COMPLETE = "COMPLETE",
  CANCELLED = "CANCELLED",
  FAILED = "FAILED",
  NMI_REQUESTED = "NMI_REQUESTED",
  NMI_ALLOCATED = "NMI_ALLOCATED",
  CONNECTION_REQUESTED = "CONNECTION_REQUESTED",
  CONNECTED = "CONNECTED",
  SERVICE_LINE_REQUESTED = "SERVICE_LINE_REQUESTED",
  SERVICE_LINE_COMPLETED = "SERVICE_LINE_COMPLETED",
  METER_REQUESTED = "METER_REQUESTED",
}

export type RequestEvent = {
  status: RequestLifecycle;
  eventDate: string;
};

export enum RequestTypeEnum {
  NEW_CONNECTION = "NEW_CONNECTION",
  HANDOVER = "HANDOVER",
  CHANGE_SUPPLY = "CHANGE_SUPPLY",
  REMOVE_SUPPLY = "REMOVE_SUPPLY",
}

export enum OperationalTeamEnum {
  TIER_1 = "TIER_1",
  TIER_2 = "TIER_2",
  TIER_3 = "TIER_3",
  CES = "CES",
  MSBG = "MSBG",
  MSBG_TELCO = "MSBG_TELCO",
  MSBG_COUNCIL = "MSBG_COUNCIL",
}

export type PremiseRequestSummary = {
  service_type: ServiceTypeEnum;
  request_id: string;
  submitted: string;
  expected: string;
  updated: string;
  currentStep: string;
  siteSupervisorName: string;
  service_identifier: string;
  request_status:
    | ChangeRequestComputedStatusEnum
    | RemoveSupplyComputedStatusEnum;
  raw_request_status: string;
  accountPayer: AccountPayerEnum;
  connection_type: ConnectionTypeEnum;
  request_type: RequestTypeEnum;
  linkedHandoverRequestId: string;
  latest_message_direction: MessageDirectionEnum;
  latest_message_processed: boolean;
  requestTimeline: RequestEvent[];
  has_unread_message_for_user?: boolean;
  collaborator_name?: string;
  message_pause: boolean;
  journey_id: string | null;
  distributor_application_id: string | null;
  request_channel: RequestChannelEnum | null;
  start_date: string | null;
  scheduled_start_date?: string;
  operational_team: OperationalTeamEnum | null;
};

export interface PremiseDetails {
  id: string;
  loc_id: string;
  unit_type: string;
  unit_number: string;
  floor_type: string;
  floor_number: string;
  site_details: SiteDetails;
}

export type SiteDetails = {
  id: string;
  street_number?: string;
  lot_number?: string;
  dp_number?: string;
  block_number?: string;
  section_number?: string;
  street_suffix?: string;
  building_name?: string;
  street_name: string;
  street_type: string;
  suburb: string;
  state: State;
  postcode: string;
};

export interface PremiseRequest {
  premise: PremiseDetails;
  premise_request_summary: PremiseRequestSummary;
}
export interface ChangeRequest {
  premise: PremiseDetails;
  premise_request_summary: PremiseRequestSummary;
}

export type ChangeRequestTableRow = {
  serviceType: ServiceTypeEnum;
  requestType: RequestTypeEnum;
  connectionType: ConnectionTypeEnum;
  address: string;
  id: string;
  nmi: string;
  lodgedDate: string | null;
  updatedDate: string | null;
  status: string;
  statusText: string;
  journeyId: string | null;
  distributorApplicationId: string | null;
  requestStatus:
    | ChangeRequestComputedStatusEnum
    | RemoveSupplyComputedStatusEnum;
  state: State;
  requestChannel: RequestChannelEnum | null;
  operationalTeam: string;
};

export type ChangeRequestTableRows = ChangeRequestTableRow[];
/* eslint-enable */

export enum SortDirectionEnum {
  ASC = "ASC",
  DESC = "DESC",
}

export enum SortByEnum {
  SERVICE_TYPE = "SERVICE_TYPE",
  CONNECTION_TYPE = "CONNECTION_TYPE",
  REQUEST_ID = "REQUEST_ID",
  SUBMITTED = "SUBMITTED",
  UPDATED = "UPDATED",
  REQUEST_STATUS = "REQUEST_STATUS",
  RAW_REQUEST_STATUS = "RAW_REQUEST_STATUS",
  ADDRESS = "ADDRESS",
  MESSAGE = "MESSAGE",
}
export enum PropertyType {
  RESIDENTIAL = "RESIDENTIAL",
  COMMERCIAL = "COMMERCIAL",
}

export interface FetchPremisesRequest {
  page?: number;
  limit?: number;
  sortDirection?: SortDirectionEnum;
  sortBy?: SortByEnum;
  incremental?: boolean;
}
